export default __webpack_public_path__ + "static/media/onpath-stack1.webp";